import React from 'react'
import PropTypes from 'prop-types'

import {
  StyledCard,
  StyleHeading,
  StyledRichText,
} from './SpecificContent.styled'
import HeadingSizeEnum from '../../enums/headingSize'
import RichText from '../RichText/RichText'
import CKEditorContent from '../CKEditorContent/CKEditorContent'

const SpecificContent = (props) => {
  const { text, textHtml, title } = props

  const styledText = textHtml ? (
    <CKEditorContent html={textHtml.content} />
  ) : (
    <RichText bodyRichText={text} />
  )

  return (
    <StyledCard>
      {title && <StyleHeading label={title.title} size={HeadingSizeEnum.h3} />}
      <StyledRichText>{styledText}</StyledRichText>
    </StyledCard>
  )
}

SpecificContent.propTypes = {
  text: PropTypes.object.isRequired,
  title: PropTypes.object,
}

export default SpecificContent
